import React from 'react';
import { Col, ColProps, Row } from 'antd';
import classNames from 'classnames';

import { LeadDetailsModel } from '@/typings/models/Lead';
import styles from './index.less';
import { F } from '@/utils/intl';
import CustomerStylesProps from './CustomerStylesProps';

const CustomerPreferencesList = ({leadDetails, grid, className}: {
  leadDetails: LeadDetailsModel,
  grid: ColProps,
  className?: ColProps,
}) => {
  if(!leadDetails?.customer?.styles) return null
  const preferences = Object.keys(leadDetails?.customer?.styles)
  if (preferences.length === 0) return null

  return <div className={classNames(styles.leadPreferencesListContainer, className)}>
    <div className={styles.leadPreferencesListContent}>
      <div className={styles.preferencesTitle}>
        <F id={"common.preferences"} defaultMessage={"Preferences"}/>
      </div>
      <Row gutter={[16, 16]}>
        {preferences.map((style, index) => (
          <Col {...grid} key={index}>
            <div className={styles.leadDetailsFieldName} style={{marginBottom: 5}} title={style}>
              {style}
            </div>
            <div className={styles.leadDetailsFieldValue}>
            <CustomerStylesProps lead={leadDetails} styleFieldKey={style} />
            </div>
          </Col>
        ))}
      </Row>
    </div>
  </div>
}

export default CustomerPreferencesList
